var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Link.tsx
import { forwardRef } from "react";
import { default as MuiLink } from "@mui/material/Link";
import { OpenInNewIcon } from "@availity/mui-icon";
import { jsx, jsxs } from "react/jsx-runtime";
var ABSOLUTE_URL_REGEX = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/;
var WINDOWS_PATH_REGEX = /^[a-zA-Z]:\\/;
function isAbsoluteUrl(url) {
  if (WINDOWS_PATH_REGEX.test(url)) {
    return false;
  }
  return ABSOLUTE_URL_REGEX.test(url);
}
var getUrl = (url = "") => {
  return `/public/apps/home/#!/loadApp?appUrl=${encodeURIComponent(url)}`;
};
var getLocation = (href) => {
  const location = document.createElement("a");
  location.href = href;
  return location;
};
var setRel = (url, target, absolute) => {
  if (target === "_blank" && absolute) {
    const dest = getLocation(url);
    if (dest.hostname !== window.location.hostname) {
      return "noopener noreferrer";
    }
  }
  return void 0;
};
var Link = forwardRef((props, ref) => {
  const _a = props, { href, target = "_self", children, onClick, loadApp = true, rel, iconPosition = "start" } = _a, rest = __objRest(_a, ["href", "target", "children", "onClick", "loadApp", "rel", "iconPosition"]);
  const absolute = isAbsoluteUrl(href);
  const encode = !(absolute || !loadApp);
  const url = encode ? getUrl(href) : href;
  const NewWindowIcon = target === "_blank" ? /* @__PURE__ */ jsx(OpenInNewIcon, {}) : null;
  const startIcon = iconPosition === "start";
  const endIcon = iconPosition === "end";
  return /* @__PURE__ */ jsx(
    MuiLink,
    __spreadProps(__spreadValues({
      href: url,
      target: loadApp ? "_top" : target,
      onClick: (event) => onClick && onClick(event, url),
      rel: rel || setRel(url, target, absolute)
    }, rest), {
      ref,
      children: /* @__PURE__ */ jsxs("span", { children: [
        startIcon && NewWindowIcon,
        " ",
        children,
        " ",
        endIcon && NewWindowIcon
      ] })
    })
  );
});
export {
  Link
};
